import styled from 'styled-components';

export const ImageWrapper = styled.div`
	width: 360px;

	img {
		width: 100%;
		height: auto;
	}

	@media (min-width: 600px) {
		display: none;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	height: 100vh;
`;

export const WrapperRest = styled(Wrapper)`
	@media (min-width: 600px) {
		border-radius: 8px;
		background: #fff;
		width: 690px;
		margin: 12px auto;
		height: fit-content;
	}
`;

export const ActionWrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	margin: 0px 0;
	margin-top: -60px;

	@media (max-width: 600px) {
		flex-wrap: wrap;

		div {
			position: relative;
			width: 100vw;
			z-index: 100;
		}
	}

	@media (min-width: 600px) {
		padding-top: 5vh;
		flex-wrap: wrap;
		max-width: 700px;
		justify-content: unset;
		height: 100%;

		div {
			position: relative;
			width: 700px;
			z-index: 100;
		}
		margin-top: -60px;
	}
`;
